module.exports = {
	"_from": "web3-provider-engine",
	"_id": "web3-provider-engine@13.7.1",
	"_inBundle": false,
	"_integrity": "sha512-TxFMlF3NRnKoZdtcUBwnQPUADk4rNWRQoWyI3OOq/VYMylPgtbYhXGmqUw/glXTIS0GUbSpRzqDKrVhvzjZcIg==",
	"_location": "/web3-provider-engine",
	"_phantomChildren": {
		"lodash": "4.17.4"
	},
	"_requested": {
		"type": "tag",
		"registry": true,
		"raw": "web3-provider-engine",
		"name": "web3-provider-engine",
		"escapedName": "web3-provider-engine",
		"rawSpec": "",
		"saveSpec": null,
		"fetchSpec": "latest"
	},
	"_requiredBy": [
		"#USER",
		"/"
	],
	"_resolved": "https://registry.npmjs.org/web3-provider-engine/-/web3-provider-engine-13.7.1.tgz",
	"_shasum": "5dcac08924cb22e9cbb8cb4116437213cf8adf7d",
	"_spec": "web3-provider-engine",
	"_where": "C:\\Users\\nktpa\\Desktop\\atlantida-solutions",
	"author": "",
	"browser": {
		"request": false
	},
	"bugs": {
		"url": "https://github.com/MetaMask/provider-engine/issues"
	},
	"bundleDependencies": false,
	"dependencies": {
		"async": "^2.5.0",
		"clone": "^2.0.0",
		"eth-block-tracker": "^2.2.2",
		"eth-sig-util": "^1.4.2",
		"ethereumjs-block": "^1.2.2",
		"ethereumjs-tx": "^1.2.0",
		"ethereumjs-util": "^5.1.1",
		"ethereumjs-vm": "^2.0.2",
		"fetch-ponyfill": "^4.0.0",
		"json-rpc-error": "^2.0.0",
		"json-stable-stringify": "^1.0.1",
		"promise-to-callback": "^1.0.0",
		"readable-stream": "^2.2.9",
		"request": "^2.67.0",
		"semaphore": "^1.0.3",
		"solc": "^0.4.2",
		"tape": "^4.4.0",
		"xhr": "^2.2.0",
		"xtend": "^4.0.1"
	},
	"deprecated": false,
	"description": "[![Greenkeeper badge](https://badges.greenkeeper.io/MetaMask/provider-engine.svg)](https://greenkeeper.io/)",
	"devDependencies": {
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-0": "^6.24.1",
		"browserify": "^14.0.0"
	},
	"homepage": "https://github.com/MetaMask/provider-engine#readme",
	"license": "ISC",
	"main": "index.js",
	"name": "web3-provider-engine",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/MetaMask/provider-engine.git"
	},
	"scripts": {
		"bundle": "mkdir -p ./dist && npm run bundle-engine && npm run bundle-zero",
		"bundle-engine": "browserify -s ProviderEngine -e index.js > dist/ProviderEngine.js",
		"bundle-zero": "browserify -s ZeroClientProvider -e zero.js > dist/ZeroClientProvider.js",
		"test": "node test/index.js"
	},
	"version": "13.7.1"
};


//////////////////
// WEBPACK FOOTER
// ./~/web3-provider-engine/package.json
// module id = 1225
// module chunks = 0